import React, { FC, useCallback } from "react";
import { useTagManagement } from "../hooks/useTagManagement";
import { ManageTags } from "./ManageTags";
import { IContact } from "../types/Contact";

interface IAddTagsToContactProps {
  contact: IContact;
  teamId: number;
  refetchContactsData: () => void;
  isOpen: boolean;
  onClose: () => void;
}

export const AddTagsToContact: FC<IAddTagsToContactProps> = ({
  contact,
  teamId,
  refetchContactsData,
  isOpen,
  onClose,
}) => {
  const { resetTagManagement } = useTagManagement({
    teamId,
    contact,
    refetchContactsData,
  });

  const handleClose = useCallback(() => {
    resetTagManagement();
    onClose();
  }, [resetTagManagement, onClose]);

  if (!contact) return null;

  return (
    <ManageTags
      isOpen={isOpen}
      onClose={handleClose}
      teamId={teamId}
      contact={contact}
      refetchContactsData={refetchContactsData}
    />
  );
};
